import { render, staticRenderFns } from "./OverduePrompt.vue?vue&type=template&id=259578bd&"
import script from "./OverduePrompt.vue?vue&type=script&lang=js&"
export * from "./OverduePrompt.vue?vue&type=script&lang=js&"
import style0 from "./OverduePrompt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports